import type {ReactNode} from 'react'

export type PillOpcion<T extends string> = {key: T; label: string; disabled?: boolean}

export function VistaPills<T extends string>({
  label,
  opciones,
  valor,
  onPick,
  testIdPrefix,
  children,
}: {
  label: string
  opciones: PillOpcion<T>[]
  valor: T | null
  onPick: (key: T) => void
  testIdPrefix: string
  children?: ReactNode
}) {
  return (
    <div role="group" aria-label={label} className="flex flex-wrap items-center gap-x-2 gap-y-1.5">
      <span className="mr-1 font-mono text-[10px] font-medium tracking-[0.14em] text-muted-foreground uppercase">
        {label}
      </span>
      {opciones.map((o) => (
        <button
          key={o.key}
          type="button"
          data-testid={`${testIdPrefix}-${o.key}`}
          onClick={() => onPick(o.key)}
          disabled={o.disabled}
          aria-pressed={valor === o.key}
          className={
            valor === o.key
              ? 'rounded-full bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground shadow-card'
              : 'rounded-full border border-input px-3 py-1 text-xs text-muted-foreground transition-colors hover:border-primary/40 hover:text-foreground disabled:opacity-40 disabled:hover:border-input'
          }>
          {o.label}
        </button>
      ))}
      {children && <span className="ml-0.5">{children}</span>}
    </div>
  )
}
